import services from '@/api/services';
import StoreConstructor from '@/store/core/StoreConstructor';
import { action, observable } from 'mobx';

export default class ExternalTaxPayersStore extends StoreConstructor {
  @observable isFetching = false;

  @action async testTaxDay() {
    this.isFetching = true;
    try {
      await services.internal.testTaxDay();
    } catch (e: any) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }

  @action async testTaxMonth() {
    this.isFetching = true;
    try {
      await services.internal.testTaxMonth();
    } catch (e: any) {
      console.error(e);
    } finally {
      this.isFetching = false;
    }
  }
}
